import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { RolService } from '../services/rol/rol.service';
import Rol from '../../models/Rol';
export interface RolState {
  rolesList: Rol[];
  status: 'idle' | 'loading' | 'failed';
}
const initialState: RolState = {
  rolesList: [{}],
  status: 'idle',
};

const rolService = new RolService();
export const rolSlice = createSlice({
  name: 'rol',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setRol: (state, action) => {
      state.rolesList = action.payload;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder.addCase(getRoles.fulfilled, (state, action) => {
      let status = action.payload.status
      state.rolesList = status ? action.payload.data : [];
    });
  },
});

export const getRoles = createAsyncThunk('get_rol', async () => {
  return rolService.getRoles();
});
export const postRole = createAsyncThunk('post_rol', async (rol: Rol) => {
  return rolService.postRole(rol);
});
export const updateRole = createAsyncThunk('update_role', async (role: Rol) => {
  return rolService.updateRole(role);
});
export const deleteRole = createAsyncThunk(
  'delete_rol',
  async (rolId: number) => {
    return rolService.deleteRol(rolId);
  },
);

export const { setRol } = rolSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.user.value)`
export const selectRol = (state: RootState) => state.rol;

export default rolSlice.reducer;
